export default __webpack_public_path__ + "static/media/atomo.b656663d.png";